import React from "react";
import { useNavigate } from "react-router-dom";

// =============================================================
// StructuralBackButton — top-left "← Back" that ALWAYS routes to
// the structural parent of the current sub-page. We deliberately
// do NOT use navigate(-1) so deep-linked or refreshed sub-pages
// still land somewhere coherent (e.g. /members/m4 → /members).
// =============================================================
export default function StructuralBackButton({ to, label = "← Back", testId = "structural-back", style }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="btn btn-outline btn-sm"
      data-testid={testId}
      onClick={() => navigate(to)}
      style={{ flexShrink: 0, ...style }}
    >
      {label}
    </button>
  );
}
